import { XERO_SNAPSHOT_FETCHED } from "utils/constants";

export const fetchXeroSnapshotByOrgId = (orgId) => (dispatch, getState) => {
  const { api } = getState().app;

  api.fetchXeroSnapshotByOrgId(orgId)
    .then(data => {
      dispatch({
        type: XERO_SNAPSHOT_FETCHED,
        data: { xeroSnapshot: (data && data.xeroSnapshot) || {} }
      })
    })
};



// WEBPACK FOOTER //
// ./src/actions/xero.js